import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { useReactiveVar } from '@apollo/client'
import { Button } from '@wmgtech/legato'

import { activeProjectVar, showArchivedDialogVar } from 'modulesCommon/store'
import { ArchivedDialog } from 'modulesCommon/Projects/containers'
import { useShowArchivedGrowl } from 'modulesCommon/Projects/serviceHooks/useShowArchivedGrowl'

const ProjectEditButton: FC = () => {
  const navigate = useNavigate()
  const activeProject = useReactiveVar(activeProjectVar)

  const handleProject = () => (activeProject?.active ? navigate('edit', { relative: 'path' }) : showArchivedDialogVar(true))

  useShowArchivedGrowl()
  return activeProject?.editable ? (
    <>
      <Button
        data-edit-mode
        label={`${activeProject?.active ? 'Edit' : 'Activate'} Project`}
        colorType="secondary-black"
        containerStyle="outline"
        size="md"
        secondaryIcon={activeProject?.active ? 'pencil' : 'box-archive'}
        onClick={handleProject}
      />
      <ArchivedDialog />
    </>
  ) : null
}

export default ProjectEditButton
